import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩国漫画在线阅读`}
          title={`${comic.title} - 免费韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
              </span>
              {comic.rating}
            </span>
            <span className="whitespace-nowrap">
              <i className="ri-eye-line mr-0.5"></i>
              {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}
            </span>
          </div>
        </div>
      </div>
      <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 line-clamp-1">{comic.author} · {comic.category}</p>
    </Link>
  );
}